//* 배송완료사진 업로드 공용 훅 (모달 / 카드 퀵 드롭 공유)
import { useState } from 'react';

import { useRecoilValue } from 'recoil';

import { updateShopOrder } from '@shared/api/shopOrder/shopOrder.controller';
import { shopOrderListForSellerUrl } from '@shared/api/shopOrder/shopOrder.hook';
import { ShopOrderForSeller } from '@shared/api/shopOrder/shopOrder.interface';
import { postImage } from '@shared/api/uploadImage';
import {
  notificateError,
  notificateSuccess,
} from '@shared/plugIn/ant-notification/ant-notifiaction';
import { notificationInstanceAtom } from '@shared/state/atom/notification.atom';
import { useAuth } from '@shared/state/hooks/useAuth';
import { useQueryClient } from 'react-query';

export const useDeliveredImageUpload = (order: ShopOrderForSeller) => {
  const notifiacationInstance = useRecoilValue(notificationInstanceAtom);
  const { assetRole, sellerRole } = useAuth();
  const queryClient = useQueryClient();
  const [isUploading, setIsUploading] = useState(false);

  const upload = async (file: File) => {
    setIsUploading(true);
    try {
      const deliveredImage = await postImage(file, assetRole());
      const shopOrderImageUpdate = {
        _id: order._id,
        'deliveryDetail.deliveredImage': deliveredImage._id,
      };
      await updateShopOrder(shopOrderImageUpdate, sellerRole());
      notificateSuccess(notifiacationInstance, '업로드 성공');
      await queryClient.invalidateQueries(shopOrderListForSellerUrl(sellerRole()));
      return true;
    } catch (err: any) {
      notificateError(notifiacationInstance, '실패');
      console.log('deliveredImage upload failed' + err?.response?.data);
      return false;
    } finally {
      setIsUploading(false);
    }
  };

  return { upload, isUploading };
};
